import { UserManagerSettings } from "oidc-client-ts";

function getServerBaseURL(): string {
    if (BUILD_LOCAL) {
        return 'http://127.0.0.1/api/archipad/www/';
    }

    if (BUILD_LOCAL_DOCKER) {
        return 'http://127.0.0.1:62010/';
    }

    if (BUILD_PROD) {
        return 'https://api.archipad-services.com/';
    }

    return 'https://stage-api.bigsool.io/';
}

function getOAuthClientConfiguration(): Partial<UserManagerSettings> {
    if (BUILD_PROD) {
        return {
            authority: OAUTH_AUTHORITY ?? 'https://auth.archipad.com/',
            client_id: OAUTH_CLIENT ?? '981a33d6-7231-4b82-9869-7530fb97a7e4',
            extraQueryParams: {
                audience: "prod.archiweb-api",
            },
        };
    }
    return {
        authority: OAUTH_AUTHORITY ?? 'https://auth.archipad.dev/',
        client_id: OAUTH_CLIENT ?? 'acf6d41d-e778-47cd-926d-29f9519e1d35',
        extraQueryParams: {
            audience: "stage.archiweb-api",
        },
    };
}

function getProfileURI(): string {
    if (PROFILE_URI){
        return PROFILE_URI;
    }

    if (BUILD_PROD){
        return "https://auth.archipad.com/";
    }
    return "https://auth.archipad.dev/";
}

function getBucket(): string {
    if (BUILD_LOCAL || BUILD_LOCAL_DOCKER) {
        return "dev-archipad-services-us";
    }

    return "stage-archipad-services-fr";
}

// NTH : Merge cloud-app/env with contractor-app/env
const config = {
    "@core/services/locale": {
        supportedLocales: ['en', 'fr', 'es', 'de', 'it'],
    },
    "@core/services/config": {
        configPath: 'config',
        appVersion: '1.0',
        clientName: 'contractor',
        locale: 'en',
    },
    "@archipad/backend/project/dependenciesManager": {
        platform: "cloud",
    },
    "@archipad/report/report-generation-service": {
        reportGeneratorEnv: REPORT_GENERATOR_ENV,
	},
    "@archipad/oauth-client": getOAuthClientConfiguration(),
    "@archipad/profile": {
        profileURI: getProfileURI(),
    },
    "featureFlags": {
        "plusAuthenticationServer": true,
    },
};

const stage = {
    /** @TOOL Google Analytics test account */
    // "GTAG_ID": "G-X44CRH8N6C",

    "sentry": {
        environment: "stage",
        release: `archipad-mobi@${BUILD_REVISION}`,
    },

    "@archipad/backend/rpc/bootstrap": {
        serverBaseUrl: getServerBaseURL(),
        optimizeCorsPreflight: false,
    },
    "@ui-archipad/backend/file-upload": {
        apiKey: "A5PFJScGyQb1CEPayM00pz",
        bucket: getBucket(),
    },
    "@ui-archipad/backend/archiweb/product": {
        apiKey: "pk_test_DQiAlW3v2J2Jb65foqjJCWRi",
    },
};

const prod = {
    /** @todo GTAG replace with the correct ID */
    "GTAG_ID": "G-T4N992704N",

    "sentry": {
        dsn: "https://a7f86dbd1a194e6fba2139ec79c7790f@o449271.ingest.sentry.io/5431916",
        environment: "production",
        release: `archipad-mobi@${BUILD_REVISION}`,
    },

    "@archipad/backend/rpc/bootstrap": {
        serverBaseUrl: "https://api.archipad-services.com/",
        optimizeCorsPreflight: false,
    },
    "@ui-archipad/backend/file-upload": {
        apiKey: "AJ1PcuabPQWP4sfcfckFVz",
        bucket: "archipad-services-fr",
    },
    "@ui-archipad/backend/archiweb/product": {
        apiKey: "pk_live_Le3JdOb6Cmv4DIXDYHzn7e7X",
    },
}

const envConfig = Object.assign({}, config, BUILD_PROD ? prod : stage);

export default envConfig;
